import { deviceLinkLocalhostRoot, IsSuccessResult } from "./Devices";
import { DeviceNotification } from "./Models/DeviceNotification";
import { HashResult } from "./Models/HashResult";
import { RecordingFile } from "./Models/Cough/RecordingFileEnum";

export enum SubjectState {
    InStudy = 0,
    Practice = 1,
    Certification = 2,
}

export interface VitaloJak1Configuration {
    subjectNumber: string;
    subjectGuid: string;
    subjectState: SubjectState;
    visitGuid: string;
    deviceSerialNumber: string;
    mediaSerialNumber: string;
    assessmentKey: string;
    assessmentLabel: string;
    assessmentGuid: string;
    siteTimeZone?: string;
    minimumRecordingDuration: string;
    started?: string;
    ended?: string;
    duration?: number;
}

export interface VitaloJak1LogFile {
    start?: string;
    end?: string;
}

export const ApiGetConfiguration = (deviceId: string): Promise<VitaloJak1Configuration> => {
    return fetch(`${deviceLinkLocalhostRoot}/devices/${deviceId}/GetConfiguration`, {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
        },
    })
        .then(response => {
            if (!response.ok) return null;
            if (response.status === 204) return null;

            return response.json();
        })
}

export const ApiSetConfiguration = (deviceId: string, configuration: VitaloJak1Configuration): Promise<boolean> => {
    return fetch(`${deviceLinkLocalhostRoot}/devices/${deviceId}/SetConfiguration`, {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
        },
        body: JSON.stringify(configuration),
    })
        .then(response => response.ok)
}

export const ApiGetIsTrainingCard = (deviceId: string): Promise<IsSuccessResult> => {
    return fetch(`${deviceLinkLocalhostRoot}/devices/${deviceId}/GetIsTrainingCard`, {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
        },
    })
        .then(response => response.json())
}

export const ApiGetMicrophoneRecording = (deviceId: string, bytesFrom: number, bytesTo: number): Promise<Response> => {
    return fetch(`${deviceLinkLocalhostRoot}/devices/${deviceId}/GetMicrophoneRecording`, {
        method: 'POST',
        headers: {
            'Range': `bytes=${bytesFrom}-${bytesTo}`,
            'content-type': 'application/json',
        },
    })
        .then(response => response);
}

export const ApiGetSensorRecording = (deviceId: string, bytesFrom: number, bytesTo: number): Promise<Response> => {
    return fetch(`${deviceLinkLocalhostRoot}/devices/${deviceId}/GetSensorRecording`, {
        method: 'POST',
        headers: {
            'Range': `bytes=${bytesFrom}-${bytesTo}`,
            'content-type': 'application/json',
        },
    })
        .then(response => response);
}

export const ApiGetMicrophoneRecordingHash = (deviceId: string): Promise<HashResult> => {
    return fetch(`${deviceLinkLocalhostRoot}/devices/${deviceId}/GetMicrophoneRecordingHash`, {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
        },
    })
        .then(response => response.json());
}

export const ApiGetSensorRecordingHash = (deviceId: string): Promise<HashResult> => {
    return fetch(`${deviceLinkLocalhostRoot}/devices/${deviceId}/GetSensorRecordingHash`, {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
        },
    })
        .then(response => response.json());
}

export const ApiGetLogFile = (deviceId: string): Promise<VitaloJak1LogFile | null> => {
    return fetch(`${deviceLinkLocalhostRoot}/devices/${deviceId}/GetLogFile`, {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
        },
    })
        .then(ProcessLogFileResponse)
}

export const ApiGetLogFileStream = (deviceId: string): Promise<Response> => {
    return fetch(`${deviceLinkLocalhostRoot}/devices/${deviceId}/GetLogFileStream`, {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
        },
    })
        .then(response => response);
}

export const ApiGetLogHash = (deviceId: string): Promise<HashResult> => {
    return fetch(`${deviceLinkLocalhostRoot}/devices/${deviceId}/GetLogHash`, {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
        },
    })
        .then(response => response.json());
}


export const ApiGetDeviceNotifications = (deviceId: string): Promise<Array<DeviceNotification>> => {
    return fetch(`${deviceLinkLocalhostRoot}/devices/${deviceId}/GetDeviceNotifications`, {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
        },
    })
        .then(response => response.json());
}

export async function ProcessLogFileResponse(response: Response): Promise<null | VitaloJak1LogFile> {
    if (response.status === 204) {
        return null;
    }

    const responseContent = await response.json();

    return responseContent;

}
